import styled from "styled-components";

// Offset below the fixed topbar (Navbar, 60px) so it stays usable to navigate away,
// while covering the page content + footer. z-index sits below the navbar/menu (1030/1031).
export const DesktopOnlyContainer = styled.div`
  position: fixed;
  top: 60px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1029;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 0 32px;
  background: ${({ theme }) => theme.global.bg.primary};
`;

export const IconWrapper = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  max-width: 320px;
`;

export const Title = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.typography.fonts.geist};
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.2px;
  text-align: center;
  color: ${({ theme }) => theme.typography.color.primary};
`;

export const Description = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.typography.fonts.geist};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.5px;
  text-align: center;
  color: ${({ theme }) => theme.typography.color.tertiary};
`;
